import { useState, useCallback } from 'react'
import { toast } from 'react-toastify'
import { useMutation, useQueryClient } from 'react-query'

import { updateMembershipGroupAPI } from 'api/memberships'
import { useMembershipsStore } from 'store/memberships'

import {
  MembershipsDataTypes,
  MembershipGroupUpdateParamsTypes,
} from 'types/memberships'

import { DATASTATUS } from 'constants/status'

export const useMemberMembershipGroupUpdate = ({
  modalClose,
  selectedRowData,
}: {
  modalClose: () => void
  selectedRowData: MembershipsDataTypes
}) => {

  const membershipGroupUpdateModStatusSet = useMembershipsStore(
    (state) => state.membershipGroupUpdateModStatusSet
  )

  const [
    membershipGroupUpdateParams,
  ] = useState<MembershipGroupUpdateParamsTypes>({
    membershipId: selectedRowData.membershipId,
    endDate: selectedRowData.endDate,
  })

  const queryClient = useQueryClient()
  const { mutateAsync } = useMutation({
    mutationFn: updateMembershipGroupAPI,
    mutationKey: 'updateMembershipGroupUpdate',
    onMutate: (values) => {
      membershipGroupUpdateModStatusSet('loading')
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: ['useMemberships'],
      })
      membershipGroupUpdateModStatusSet('success')
    },
    onError: (error) => {
      membershipGroupUpdateModStatusSet('fail')
    },
  })

  const handleGroupUpdate = useCallback(
    async (mergeParams: MembershipGroupUpdateParamsTypes) => {
      try {
        const response = await mutateAsync({
          ...membershipGroupUpdateParams,
          ...mergeParams,
        })
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        toast.success('Membership group update successful.')
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(`Membership group update error.`)
        // modalClose()
      } finally {
        // console.log('')
        // modalClose()
      }
      modalClose()
    },
    [mutateAsync]
  )

  return {
    memberMembershipGroupUpdateParams: membershipGroupUpdateParams,
    memberHandleMembershipGroupUpdate: handleGroupUpdate,
  }
}
